<script lang="ts">
	import Button from '$lib/components/button/Button.svelte';
	import FontSpan from '../typography/FontSpan.svelte';

	export let actionName: string = '';
	export let actionHandler: () => void = () => {};
	export let desciption: string;
</script>

<div class="flex flex-col m-auto empty-state">
	<div class="flex m-auto">
		<slot />
	</div>
	<FontSpan varient="body-B-07" class="m-auto text-gray-50">{desciption}</FontSpan>
	{#if actionName.length > 0}
		<Button class="w-40 m-auto mt-4" on:click={actionHandler} text={actionName} />
	{/if}
</div>

<style>
	.empty-state {
		padding: 48px 16px;
		align-items: center;
		gap: 4px;
		flex-shrink: 0;
	}
</style>
